import { createFileRoute } from "@tanstack/react-router";
import { LSA_ROOFERS } from "@/content/localPages";
import { localPageHead } from "@/content/localPageHead";
import { LocalPageView } from "@/components/marketing/LocalPageView";

export const Route = createFileRoute("/services/local-services-ads-for-roofers")({
  head: () => localPageHead(LSA_ROOFERS, { name: "Services", path: "/services" }),
  component: LsaForRoofers,
});

function LsaForRoofers() {
  return <LocalPageView page={LSA_ROOFERS} />;
}
